import InfoTag from "../infoTag.infoBar.component";
import { useState, useContext, useEffect } from "react";
import CloseButton from "../../buttons/close.button";

import { SelectedOpenPartOrdersContext } from "../../../contexts/parts/selectedOpenPartOrders.part.context";
import SelectedPartsModal from "../../modals/parts/selectedParts.part.modal";

const SelectedInfoTag = ({ children }) => {
  const { selectedOpenPartOrders, resetSelectedOpenPartOrders } = useContext(
    SelectedOpenPartOrdersContext
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedOpenPartOrdersCount, setSelectedOpenPartOrdersCount] =
    useState(0);

  useEffect(() => {
    setSelectedOpenPartOrdersCount(selectedOpenPartOrders?.length || 0);
  }, [selectedOpenPartOrders]);
  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  return (
    <>
      <InfoTag>
        <div
          onClick={openModal}
          className="px-2 py-1 hover:bg-secondary rounded-full font-ubuntuRegular active:font-bold active:text-white active:skew-y-0 hover:skew-y-3 cursor-pointer flex flex-row items-center justify-center h-full w-full"
        >
          Selected: {selectedOpenPartOrdersCount}
        </div>
        <CloseButton onClose={resetSelectedOpenPartOrders} size="sm" />
      </InfoTag>
      <SelectedPartsModal isOpen={modalIsOpen} onClose={closeModal} />
    </>
  );
};

export default SelectedInfoTag;
